import gql from 'graphql-tag';

export default gql`
  mutation createAttendance($condominiumId: Int!) {
    createAttendance(condominiumId: $condominiumId)
  }
`;
